// This file is automatically generated. Do not edit manually.

import { SalesContractView } from "src/api/generated/erp/db/types/tables/salesContractView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerSalesContractsDataGridApi {
	export async function getSalesContracts(args: { customerId: number }): Promise<Array<SalesContractView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/pricing/salesContracts/getSalesContracts",
			method: "POST",
			data: {
				customerId: args.customerId,
			},
		});
		return response as Array<SalesContractView>;
	}
}
